import { render, staticRenderFns } from "./EditAdvice.vue?vue&type=template&id=966c690a"
import script from "./EditAdvice.vue?vue&type=script&lang=js"
export * from "./EditAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports